$(document).ready(function () {
    if ($('.product-recommendations').length) {
        getProductRecommendations();
    }

    if ($('.shopify-cart-qty').length) {
        updateShopifyDetails();
    }

    $('.add-to-cart').on('click', function () {
        const self = this;

        var itemData = {
            items: [
                {
                    quantity: 1,
                    id: $(this).attr('data-variant'),
                    properties: {
                        'First name': 'Caroline'
                    }
                }
            ]
        };

        $.ajax({
            url: '/cart/add.js',
            data: itemData,
            type: 'POST',
            beforeSend: function () {
                $(self).html('Please wait...');
            },
            complete: function () {
                updateShopifyDetails();
                $(self).html('Added to cart');
            }
        })
    })

    $('.product-images').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.product-images-nav'
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var newHeight = $('[data-slick-index="' + nextSlide + '"]').height();

        $('.product-images').css("height", newHeight);
    });

    $('.product-images-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.product-images',
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        vertical: true,
        responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
});

// Functions
const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function getProductRecommendations() {
    var $container = $('.product-recommendations');

    var baseUrl = $container.data('baseUrl');
    var productId = $container.data('productId');
    var limit = $container.data('limit');

    var getProductUrl = baseUrl + '?section_id=product-recommendations&limit=' + limit +
        '&product_id=' + productId;

    $.ajax({
        url: getProductUrl,
        type: 'get',
        success: function (res) {
            $container.html(res);
        }
    })
}


function updateShopifyDetails() {
    $.ajax({
        url: '/cart.js',
        type: 'GET',
        dataType: 'json',
        success: function (res) {
            $('.shopify-cart-qty').html(res.item_count);

            if ($('.shopify-cart-total').length) {
                $('.shopify-cart-total').html(res.currency + numberWithCommas(res.total_price));
            }
        }
    })
}

//new code

// Event listener for the share button
document.getElementById('share-button').addEventListener('click', shareProduct);

// Function to handle the share action
function shareProduct() {
  // Check if the Web Share API is available
  if (navigator.share) {
    // Use the Web Share API to trigger the share action
    navigator.share({
      title: document.title,
      text: 'Check out this product',
      url: window.location.href
    })
      .then(() => console.log('Product shared successfully'))
      .catch((error) => console.error('Error sharing product:', error));
  } else {
    // Implement custom sharing functionality if the Web Share API is not available
    // This could involve opening a sharing dialog or copying the product URL to the clipboard
    // You can use external libraries or create your own custom sharing functionality
    console.log('Web Share API not supported');
  }
}

$(document).on('click', '.circle-radio input', function(){
  let id = $(this).val();
  let price = $(this).attr('price');
  $("select[name='id'").val(id);
  const price_text = `<span class="product-price primary-txt">${price}</span>`;
  $('.price-info').html(price_text);
})


